export default "__VITE_ASSET__kmDZAvlX__"